import Repository from "./Repository";

const globalParameters = "/global-parameters";

export default {
  list: () => Repository.get(`${globalParameters}/`),
  simplifiedList: () => Repository.get(`${globalParameters}/simplified_list/`),
  patch: (id, payload) =>
    Repository.patch(`${globalParameters}/${id}/`, payload),
};
